export enum CustomConfigType {
    PORTALS_CONFIG = 'portalsConfig',
    BRANDING = 'branding',
    BOOKING_TYPES = 'bookingTypes',
}
